import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '60px 20px',
          textAlign: 'center',
          color: 'var(--text)',
          minHeight: '50vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>😢</div>
          <h2 style={{ color: 'var(--text)', marginBottom: '10px' }}>抱歉，页面出现了错误</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: '20px' }}>
            {this.state.error?.message || '未知错误'}
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button 
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 20px',
                cursor: 'pointer',
                background: 'var(--accent)',
                color: '#fff',
                border: 'none',
                borderRadius: '4px'
              }}
            >
              刷新页面
            </button>
            <button 
              onClick={() => window.history.back()}
              style={{
                padding: '10px 20px',
                cursor: 'pointer',
                background: 'transparent',
                color: 'var(--text)',
                border: '1px solid var(--border)',
                borderRadius: '4px'
              }}
            >
              返回上页
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
